<h1 mat-dialog-title>
    {{'alert.notification' | translate}}
    <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h1>
  <div class="row">
    <div class="col-2 pr-0">
      <em class="material-icons confirm-ico">
        info
      </em>
    </div>
    <div class="col-10 pl-0" style="text-align: justify;">
      <div [innerHTML]="message | translate" style=" padding-top: 1px; padding-bottom: 20px;"></div>
    </div>
  </div>
  <div class="justify-content-center">
    <!-- <div class="col-12"> -->
      <img style="max-width:50%" src="./assets/images/qrcode-app/IOS.png" alt="IOS">
      <img style="max-width:50%" src="./assets/images/qrcode-app/Android.png" alt="Android">
    <!-- </div> -->
  </div>
  <div class="text-center d-flex mt-2">
    <div class="col-6" style="padding-top: 1px; padding-bottom: 20px; font-weight: bold;">IOS</div>
    <div class="col-6" style="padding-top: 1px; padding-bottom: 20px; font-weight: bold;">Android</div>
  </div>
  <div mat-dialog-actions class="justify-content-center mt-2">
    <button type="button" mat-raised-button color="primary" [mat-dialog-close]="true" (click)="onNoClick()"
      cdkFocusInitial>
      <mat-icon class="mr-0">done</mat-icon>{{'button.close' | translate}}
    </button>
  </div>